import { request, chatbotUrl}  from '../utils/request';
import {APP_CONFIG} from '../utils/config';

export function wirteFeedback(data) {
    const requestUrl = chatbotUrl(data.isDev) + APP_CONFIG.writeFeedback;

    
    return request(requestUrl, 'post', data);
}